import { Account, Investor } from "./Investor";
import { GroupedProjects, Project, ProjectTitle } from "./Project";
import { Investment } from "./Investment";
import { PossibleReturns } from "./BusinessIntelligence";
import { FBDate } from "./Globals";
import { ProjectStatus } from "./ProjectStatus";
import { UINotification } from "./Notifications"
import Post from "./Post";

export type InvestmentWithProject = {
    investment: Investment;
    project: Project;
}

export type InvestmentWithProjectTitle = {
    investment: Investment;
    possibleReturns: PossibleReturns;
    projectTitle: ProjectTitle;
    projectStatus: ProjectStatus;
    project: Project
}

export type AccountWithInvestments = {
    account: Account;
    accountValue: number;
    investments: InvestmentWithProjectTitle[];
    incompleteInvestments?: InvestmentWithProjectTitle[];
}

export type InvestmentSharedByProject = {
    amount: number;
    projectTitle: ProjectTitle;
}

export enum InvestmentActivityTypes {
    CreateInvestment = "CreateInvestmentActivity",
    Payment = "PaymentActivity",
    ContractSigned = "ContractSignedActivity"
}

export type InvestmentActivity = {
    date: FBDate;
    projectTitle: ProjectTitle;
    activity: InvestmentActivityTypes;
}

export type AccountValues = {
    activeInvestmentsExpectedReturn: number;
    activeInvestmentTotalValue: number;
    activeInvestmentAccrumulatedInterest: number;

    repaidInvestmentReturn: number;
    repaidInvestmentTotalValue: number;
    repaidInvestmentInterest: number;
}

export type Dashboard = {
    investor: Investor;
    totalAccountValue: number;
    latestInvestmentWithProject?: InvestmentWithProjectTitle;
    investmentsGroupedByAccounts: AccountWithInvestments[];
    completedInvestmentsGroupedByAccounts: AccountWithInvestments[];
    projectShares: InvestmentSharedByProject[];
    investmentActivity: InvestmentActivity[];
    dashboardNewsFeed: Post[];
    projects: Project[];
    accountValueMap: { [accountId: string]: AccountValues };
    notifications: UINotification[];
}


export type InvestInfo = {
    investor: Investor;
    investment: Investment;
    project: Project;
    morarente?: number
}

export type GroupedProjectsAndNotifications = {
    notifications: UINotification[];
    projects: GroupedProjects;
    unreadNotification: number;
    investor: Investor;
    unreadNewsCount: number;
}

export type InvestorAndAppVersion = {
    investor: Investor;
    minimumSupportAppVersion: number;
}

export enum FAQCategory {
    General = "General",
    Investment = "Investment",
    Responseability = "Responseability",
    LegalAspects = "LegalAspects",
    Profile = "Profile",
    Tax = "Tax",
    Risk = "Risk",
    Security = "Security"
}

export type FAQItem = {
    faqId: string;
    question: string;
    answerHTML: string;
    category?: FAQCategory
}

export type JuraItem = {
    juraId: string;
    name: string;
    contentHTML: string;
}

export type LocationItem = {
    locationId: string;
    name: string;
    addressForDisplay: string;
    email: string;
    phone: string;
    priority: number;
}

export const frontpageKPIFileName = "frontpagekpi.json"

export type PublicFrontpageKPI = {
    capital: string;
    projects: string;
    payments: string;
    investors: string;
    frontPageProjectId: string;
}

export type DBFrontpageKPI = {
    capital: number;
    projects: number;
    payments: number;
    investors: number;
    frontPageProjectId: string;
}

export type PublicDataBox = {
    label: string, 
    tooltip?: string,
    value: string
}

export type PublicProjectData = {
    projectDataBoxes: PublicDataBox[];
    projectCentralInvestorInformation: string[][];
}


export type AppPublicFrontpage = {
    kpis: PublicFrontpageKPI;
    frontpageProject: Project;
}
